/**
 * Lucimark lockup geometry (`lucimark-lockup-*.svg` viewBox 300×90).
 * Company profile / app header logos use this aspect ratio.
 */
export const TENANT_COMPANY_LOGO_ASPECT_RATIO = 10 / 3

/** Raster size for company logo (management app header). */
export const TENANT_COMPANY_LOGO_OUTPUT_WIDTH_PX = 600
export const TENANT_COMPANY_LOGO_OUTPUT_HEIGHT_PX = 180

/** Max rendered size in the management app top bar (`AppHeader` is 4rem tall). */
export const TENANT_APP_HEADER_LOGO_DISPLAY = {
  /** Default / mobile drawer */
  maxHeightPx: 48,
  maxWidthPx: 360,
  /** Desktop top bar (`SimpleModeNavBar`) */
  lgMaxHeightPx: 56,
  lgMaxWidthPx: 440
} as const

/**
 * Square logo raster size for player idle screen logo crop only.
 * Matches {@link ImageCropDialog} `aspect-mode="square"`.
 */
export const TENANT_PLAYER_LOGO_OUTPUT_SIZE_PX = 600

/** @deprecated Use {@link TENANT_PLAYER_LOGO_OUTPUT_SIZE_PX} or company logo constants. */
export const TENANT_BRANDING_LOGO_OUTPUT_SIZE_PX = TENANT_PLAYER_LOGO_OUTPUT_SIZE_PX

/**
 * CSS `min()` bounds for logo on player idle chrome (wide wordmarks and square tenant logos).
 * Values are viewport-relative for DOOH legibility at distance.
 */
export const PLAYER_IDLE_LOGO_DISPLAY = {
  maxWidth: 'min(88vw, 72vh)',
  maxHeight: 'min(44vh, 72vw)',
  compactMaxWidth: 'min(65vw, 28vh)',
  compactMaxHeight: 'min(28vh, 65vw)',
  /** Top bar during playback buffer; only enlarged for custom tenant logos. */
  bufferMaxHeight: 'min(14vh, 24vw)',
  bufferMaxWidth: 'min(42vw, 20vh)'
} as const
